export default function Textarea({
    textareaRef,
    channel,
    sendMessage,
    isTagging,
    setSend,
    setAttachments,
    attachments,
    tagging,
    selectingEmote,
    isSelectingEmoji
}: any) {
    return (
        <textarea
            ref={textareaRef}
            className={`w-full min-h-12 rounded-lg max-h-[24rem] px-2 py-4 overflow-y-hidden bg-brand-top text-gray-300 focus:outline-none resize-none leading-none ${textareaRef.current && textareaRef.current === document.activeElement ? 'border-blue-500' : ''
                }`}
            style={{ height: "auto" }}
            placeholder={`Message #${channel.name}`}
            rows={1}
            onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    if (!isTagging && !isSelectingEmoji) sendMessage();
                }
            }}
            onPaste={(e) => {
                const items = e.clipboardData.items;
                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    if (item.kind === "file") {
                        const file = item.getAsFile();
                        if (file) {
                            const reader = new FileReader();
                            reader.onload = async () => {
                                const formData = new FormData();
                                formData.append("image", file);
                                formData.append("type", "attachment");
                                const res = await fetch("__SITE_BASE__/api/v1/upload", {
                                    method: "POST",
                                    body: formData
                                });
                                const data = await res.json();
                                if (data.message) return;
                                setSend(true);
                                setAttachments([{ url: data.url, name: file.name }, ...attachments]);
                            };
                            reader.readAsDataURL(file);
                        }
                        e.preventDefault();
                    }
                }
            }}
            autoFocus={true}
            onChange={async(e) => {
                const trimmedValue = e.target.value.trim();
                setSend(!!(trimmedValue.length > 0 && trimmedValue.length <= 2000 && !trimmedValue.match(/^#+\s*$/) || attachments.length));
                e.target.style.height = "auto";
                e.target.style.height = e.target.scrollHeight + "px";
                selectingEmote();
                tagging();
            }}
            maxLength={2000}
        />
    )
}